import { MenuItem } from '../models/menu.model';
import { getCurrentLanguage } from 'src/app/core/helpers/utils';

// Menu de administrador
const ADMIN_MENU_ITEMS_ES: MenuItem[] = [
    {
        key: 'dashboard',
        label: 'Dashboard',
        isTitle: false,
        icon: 'mdi mdi-view-dashboard',
        url: '/dashboard',
    },
    {
        key: 'casos',
        label: 'Casos',
        isTitle: false,
        icon: 'fe-briefcase',
        url: '/casos',
    },
    {
        key: 'arbitros',
        label: 'Árbitros',
        isTitle: false,
        icon: 'fe-user-check',
        url: '/arbitros',
    },
    {
        key: 'buscador-arbitros',
        label: 'Buscador',
        isTitle: false,
        icon: 'fe-search',
        url: '/arbitros/buscador',
    },
    {
        key: 'usuarios',
        label: 'Admin',
        isTitle: false,
        icon: 'fe-user',
        url: '/usuarios',
    },
    {
        key: 'respresentates',
        label: 'Representantes',
        isTitle: false,
        icon: 'fe-users',
        url: '/representantes',
    },      
    {
        key: 'gestor-plantillas',
        label: 'Plantillas',
        isTitle: false,
        icon: 'fe-file',
        url: '/plantillas',
    },      
    {
        key: 'log-plataforma',
        label: 'Log',
        isTitle: false,
        icon: 'fe-align-justify',
        url: '/log-plataforma',
    },      
    {
        key: 'informes',
        label: 'Informes',
        isTitle: false,
        icon: 'fe-book-open',
        url: '/informes',
    }
]

// Menu de administrador
const ADMIN_MENU_ITEMS_EN: MenuItem[] = [
    {
        key: 'dashboard',
        label: 'Dashboard',
        isTitle: false,
        icon: 'mdi mdi-view-dashboard',
        url: '/dashboard',
    },
    {
        key: 'casos',
        label: 'Cases',
        isTitle: false,
        icon: 'fe-briefcase',
        url: '/casos',
    },
    {
        key: 'arbitros',
        label: 'Arbitrators',
        isTitle: false,
        icon: 'fe-user-check',
        url: '/arbitros',
    },   
    {
        key: 'usuarios',
        label: 'Admin',
        isTitle: false,
        icon: 'fe-user',
        url: '/usuarios',
    },
    {
        key: 'respresentates',
        label: 'Representatives',
        isTitle: false,
        icon: 'fe-users',
        url: '/representantes',
    },    
    {
        key: 'buscador-arbitros',
        label: 'Search',
        isTitle: false,
        icon: 'fe-search',
        url: '/arbitros/buscador',
    },   
    {
        key: 'gestor-plantillas',
        label: 'Templates',
        isTitle: false,
        icon: 'fe-file',
        url: '/plantillas',
    },      
    {
        key: 'log-plataforma',
        label: 'Log',
        isTitle: false,
        icon: 'fe-align-justify',
        url: '/log-plataforma',
    },      
    {
        key: 'informes',
        label: 'Reports',
        isTitle: false,
        icon: 'fe-book-open',
        url: '/informes',
    }
]

// Menu de usuario
const USUARIO_MENU_ITEMS_ES: MenuItem[] = [
    {
        key: 'dashboard',
        label: 'Dashboard',
        isTitle: false,
        icon: 'mdi mdi-view-dashboard',
        url: '/dashboard',
    },
    {
        key: 'mi-perfil',
        label: 'Mi Perfil',
        isTitle: false,
        icon: 'fe-sidebar',
        url: '', // Definida en topnav.component
    },
    {
        key: 'casos',
        label: 'Casos',
        isTitle: false,
        icon: 'fe-briefcase',
        url: '/casos',
    }
]

// Menu de usuario
const USUARIO_MENU_ITEMS_EN: MenuItem[] = [
    {
        key: 'dashboard',
        label: 'Dashboard',
        isTitle: false,
        icon: 'mdi mdi-view-dashboard',
        url: '/dashboard',
    },
    {
        key: 'mi-perfil',
        label: 'My Profile',
        isTitle: false,
        icon: 'fe-sidebar',
        url: '', // Definida en topnav.component
    },
    {
        key: 'casos',
        label: 'Cases',
        isTitle: false,
        icon: 'fe-briefcase',
        url: '/casos',
    }
]

// Menu de arbitro
const ARBITRO_MENU_ITEMS_ES: MenuItem[] = [
    {
        key: 'dashboard',
        label: 'Dashboard',
        isTitle: false,
        icon: 'mdi mdi-view-dashboard',
        url: '/dashboard',
    },
    {
        key: 'mi-perfil',
        label: 'Mi Perfil',
        isTitle: false,
        icon: 'fe-sidebar',
        url: '', // Definida en topnav.component
    },
    {
        key: 'casos',
        label: 'Casos',
        isTitle: false,
        icon: 'fe-briefcase',
        url: '/casos',
    }
]

// Menu de arbitro
const ARBITRO_MENU_ITEMS_EN: MenuItem[] = [
    {
        key: 'dashboard',
        label: 'Dashboard',
        isTitle: false,
        icon: 'mdi mdi-view-dashboard',
        url: '/dashboard',
    },
    {
        key: 'mi-perfil',
        label: 'My Profile',
        isTitle: false,
        icon: 'fe-sidebar',
        url: '', // Definida en topnav.component
    },
    {
        key: 'casos',
        label: 'Cases',
        isTitle: false,
        icon: 'fe-briefcase',
        url: '/casos',
    }
]

// Luego, en tu componente o servicio, decide cuál usar:
const currentLanguage = getCurrentLanguage(); // Asume que esta función devuelve 'en' o 'es'
const ADMIN_MENU_ITEMS = currentLanguage === 'en' ? ADMIN_MENU_ITEMS_EN : ADMIN_MENU_ITEMS_ES;
const USUARIO_MENU_ITEMS = currentLanguage === 'en' ? USUARIO_MENU_ITEMS_EN : USUARIO_MENU_ITEMS_ES;
const ARBITRO_MENU_ITEMS = currentLanguage === 'en' ? ARBITRO_MENU_ITEMS_EN : ARBITRO_MENU_ITEMS_ES;


// menu items for vertcal and detached layout
const MENU_ITEMS: MenuItem[] = [];

export { MENU_ITEMS, ADMIN_MENU_ITEMS, USUARIO_MENU_ITEMS, ARBITRO_MENU_ITEMS};
